/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "İptal"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Müşteri verilerine erişmek için ticari gerekçe aldınız"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "İndirme etkinliğiniz güvenlik uyumluluğu amacıyla kaydedilecek ve izlenecektir"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Devam etmek istiyor musunuz?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "İndirerek şunları kabul etmiş olursunuz:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
